// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BJKXZ","tabsBox":"styles_tabsBox__36Wuf","createButton":"styles_createButton__1Unsr"};